// src/services/CountryService.js
import api from "./api";

export function getCountries(page = 1, limit = 10, search = "", status = null) {
  return api.get(
    `/country?page=${page}&limit=${limit}&search=${search}&status=${status}`
  );
}

export function getCountriesDropdown() {
  return api.get("/country/dropdown");
}

export function getCountryById(id) {
  return api.get(`/country/${id}`);
}

export function addCountry(data) {
  return api.post("/country", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function updateCountry(id, data) {
  return api.put(`/country/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteCountry(id) {
  return api.delete(`/country/${id}`);
}
